import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouteService } from '../../services/routes';
import { CustomerService } from '../../services/customer';
import { ProductService } from '../../services/products';
import { PricelistService } from '../../services/price-lists';
import { forkJoin } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth-service';
import { CustomerFavoritesService } from '../../services/customer-favorites-service';
import { ProductUpdateService } from '../../services/product-update.service';

@Component({
  selector: 'app-sync-all',
  standalone: true,
  imports: [MatButtonModule, CommonModule],
  templateUrl: './sync-all.html',
  styleUrls: ['./sync-all.scss']
})
export class SyncAll {
  syncingRoutes = false;
  syncingCustomers = false;
  syncingProducts = false;
  syncingAll = false;

  constructor(
    private routeService: RouteService,
    private customersService: CustomerService,
    private productService: ProductService,
    private priceListService: PricelistService,
    private authService: AuthService,
    private customerFavorites: CustomerFavoritesService,
    private productUpdateService: ProductUpdateService
  ) { }

  syncRoutes() {
    this.syncingRoutes = true;
    this.routeService.get(true).subscribe({
      next: async (routes) => {
        console.log('Routes synced:', routes);
        await this.authService.updateUserInfo();
      },
      error: (err) => console.error('Error syncing routes:', err),
      complete: () => this.syncingRoutes = false
    });
  }

  async syncCustomers() {
    this.syncingCustomers = true;
    const pendingResult = await this.customersService.syncPendingCustomers();
    console.log('Pending customers synced:', pendingResult);
    this.customersService.get(true).subscribe({
      next: (customers) => {
        console.log('Customers synced:', customers);
        // After customers are refreshed, warm route last prices cache (forced)
        this.customerFavorites.getRouteCustomerProductMapAndCache({ }, true).subscribe({
          next: (map) => {
            console.log('Route last prices cached for customers:', map.size);
            // Notify OrderComponent to update products with new customer pricing
            this.productUpdateService.notifyProductUpdate();
          },
          error: (err) => console.error('Error caching route last prices:', err),
          complete: () => { /* noop */ }
        });
      },
      error: (err) => console.error('Error syncing customers:', err),
      complete: () => this.syncingCustomers = false
    });
  }

  syncProducts() {
    this.syncingProducts = true;
    forkJoin([
      this.productService.get(true),
      this.priceListService.get(true)
    ]).subscribe({
      next: ([products, priceLists]) => {
        console.log('Products synced:', products);
        console.log('Price lists synced:', priceLists);
        // Notify OrderComponent to update products with fresh data
        this.productUpdateService.notifyProductUpdate();
      },
      error: (err) => console.error('Error syncing products or price lists:', err),
      complete: () => this.syncingProducts = false
    });
  }

  async syncAll() {
    this.syncingAll = true;
    this.syncingRoutes = true;
    this.syncingCustomers = true;
    this.syncingProducts = true;

    const pendingResult = await this.customersService.syncPendingCustomers();
    console.log('Pending customers synced:', pendingResult);

    forkJoin({
      routes: this.routeService.get(true),
      customers: this.customersService.get(true),
      products: this.productService.get(true),
      priceLists: this.priceListService.get(true),
      lastPrices: this.customerFavorites.getRouteCustomerProductMapAndCache({ }, true)
    }).subscribe({
      next: ({ routes, customers, products, priceLists, lastPrices }) => {
        console.log('All data synced:');
        console.log('Routes:', routes);
        console.log('Customers:', customers);        
        console.log('Products:', products);
        console.log('Price Lists:', priceLists);        
        console.log('Last Prices:', lastPrices);
        // Notify OrderComponent to update products with fresh data
        this.productUpdateService.notifyProductUpdate();
      },
      error: (err) => {
        console.error('Error syncing all:', err);
      },
      complete: () => {
        this.syncingAll = false;
        this.syncingRoutes = false;
        this.syncingCustomers = false;
        this.syncingProducts = false;
      }
    });
  }
}

